import * as stylex from '@stylexjs/stylex';
import './theme.stylex';
import { colors, radius, font } from './theme.stylex';

// Styles shared across multiple pages/components.
export const shared = {
  muted: {
    color: "xarw3lm",
    $$css: true
  },
  card: {
    backgroundColor: "x80m72e",
    borderRadius: "xdkhd45",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x1uz70x1",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    marginBottom: "xyi6m4r",
    $$css: true
  },
  primaryButton: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    gap: "x13z6uf9",
    rowGap: null,
    columnGap: null,
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    textDecoration: "x1hl2dhg",
    textDecorationColor: null,
    textDecorationLine: null,
    textDecorationStyle: null,
    textDecorationThickness: null,
    paddingBlock: "xo0yzjp",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    borderRadius: "x1w8o7ox",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    fontWeight: "xlr2uoh",
    whiteSpace: "xuxw1ft",
    $$css: true
  }
};